import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { Responses } from 'src/app/models/interfaces/responses';
import { Logs } from 'src/app/modules/entry-control/interfaces/logs';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrl: './logs.component.css'
})
export class LogsComponent implements OnInit {
  constructor(private api: ApiService) {}
  ngOnInit(): void {
    this.getData();
  }
  ppForm = new FormGroup({
    perpage: new FormControl(30),
    q: new FormControl(''),
  });
  error: any;
  items: Logs[];
  page = 1;
  collectionSize = 0;
  perpage:number=0;
  totalPage = 0;
  /** Filtros del listado: rango de fechas (inclusive) y texto (usuario, acción o descripción). */
  filters = { from: '', to: '', q: '' };
  filterError = '';

  applyFilters() {
    if (this.filters.from && this.filters.to && this.filters.to < this.filters.from) {
      this.filterError = 'La fecha final no puede ser anterior a la inicial.';
      return;
    }
    this.filterError = '';
    this.page = 1;
    this.getData();
  }

  clearFilters() {
    this.filters = { from: '', to: '', q: '' };
    this.filterError = '';
    this.page = 1;
    this.getData();
  }

  get hasFilters(): boolean {
    return !!(this.filters.from || this.filters.to || this.filters.q.trim());
  }

  getData() {
    this.api.getLogs(this.page, { from: this.filters.from, to: this.filters.to, q: this.filters.q.trim() }).subscribe(
      (response) => {
        var data = response.data as Paginate;
        if (response.status != 'ok') {
          // Sin resultados para los filtros: se vacía la tabla en vez de dejar la búsqueda anterior.
          this.items = [];
          this.collectionSize = 0;
        }
        if (response.status == 'ok') {
          this.items = data.items as Logs[];
          this.page = data.current;
          this.collectionSize = data.count;
          console.log(this.collectionSize);
          this.perpage = data.per_page;
          this.totalPage = data.total;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }
  /**
   * Detalle de la acción: cada dato en su línea (los datos comienzan con su nombre en negrita) y respetando mayúsculas.
   * Angular sanea el HTML antes de mostrarlo.
   */
  detail(obs?: string): string {
    return (obs ?? '')
      .replace(/\s*,\s*(?=<b>)/g, '<br>')
      .replace(/,\s*$/, '')
      .split('\n')
      .join('<br>');
  }

  /** Acción principal y sección, por ejemplo «SECCIÓN PARAMETROS > CREAR» → [«CREAR», «Parametros»]. */
  actionParts(action?: string): { verb: string; area: string } {
    const parts = (action ?? '').split('>').map((x) => x.trim());
    const verb = parts.length > 1 ? parts[parts.length - 1] : parts[0] || '—';
    const area = parts.length > 1 ? parts.slice(0, -1).join(' > ').replace(/^SECCIÓN\s+/i, '') : '';
    return { verb, area };
  }

  verbClass(verb: string): string {
    const v = verb.toUpperCase();
    if (v.includes('ELIMIN') || v.includes('RETIR')) return 'bg-danger';
    if (v.includes('CREAR') || v.includes('NUEVO') || v.includes('ACTIV') || v.includes('ACCESO')) return 'bg-success';
    if (v.includes('ACTUALIZ') || v.includes('MODIF') || v.includes('EDIT')) return 'bg-warning text-dark';
    return 'bg-secondary';
  }
}
